import React from "react";
import banner8 from "../assets/banner8.jpg"; // replace with actual image path

export default function InstitutionalCapacityDevelopment() {
  return (
    <section className="py-5">

      {/* Heading */}
      <div className="text-center mb-3">
        <h2 className="main-section-title fw-bold">Institutional Capacity Development</h2>
        <p className="text-muted small">
          Building skills, systems, and structures for stronger institutions.
        </p>
      </div>

      {/* Image */}
      <div className="mb-4">
        <img 
          src={banner8} 
          alt="Institutional Capacity Development" 
          className="img-fluid rounded w-100"
        />
      </div>

      {/* Elaborative Text */}
      <div className="container">
        <p className="text-muted fs-6">
          Zamani Sabios Group provides support for developing institutional capacity, 
          focusing on enhancing skills, organisational structures, and operational systems. 
          Our services help public, private, and non-profit institutions strengthen 
          performance, efficiency, and sustainability. We offer training, process improvement, 
          and organisational development solutions tailored to meet client-specific needs 
          while ensuring long-term institutional growth.
        </p>
      </div>

    </section>
  );
}
